import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { Acesso } from 'src/app/core/acesso';
import { CarregarPerfil } from 'src/app/core/carregar-perfil';
import { AcoesPlanejamentoOficina } from '../../../../core/acoes-planejamento-oficinas';
import { DataUtilService } from "../../../../services/commons/data-util.service";

@Component({
    selector: 'listar-acoes-planejamento-oficina',
    templateUrl: './listar-acoes-planejamento-oficina.component.html',
    styleUrls: ['./listar-acoes-planejamento-oficina.component.css']
})
export class ListarAcoesPlanejamentoOficinaComponent implements OnInit {

    @Output() onAtualizarAcaoPlanejamentoOficina = new EventEmitter();
    @Output() onAdicionar = new EventEmitter();

    @Input() acoesPlanejamentoOficina: AcoesPlanejamentoOficina[];

    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

    mostrarTabela = false;
    msg: string;

    displayedColumns: string[] = ['dataInicio', 'localExecucao', 'descricao', 'statusAnalise', 'acoes'];
    dataSource: MatTableDataSource<AcoesPlanejamentoOficina> = new MatTableDataSource();

    perfilAcesso: Acesso = new Acesso();
    carregarPerfil: CarregarPerfil = new CarregarPerfil();

    filteredRequests: MatTableDataSource<AcoesPlanejamentoOficina> = new MatTableDataSource();
    descricaoFiltered: string;
    dataFiltered: string;

    constructor(private activatedRoute: ActivatedRoute,
                private dataUtilService: DataUtilService) {
    }

    ngOnInit() {
        this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);

        this.dataSource.paginator = this.paginator;
        this.carregarLista();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["acoesPlanejamentoOficina"] && !_.isEmpty(changes["acoesPlanejamentoOficina"].currentValue)) {
            this.carregarLista();
        }
    }

    getStatusLabel(statusAnalise: string): string {
        if (!statusAnalise) return 'Aguardando';
        return statusAnalise === 'A'
            ? 'Aprovado'
            : statusAnalise === 'R'
            ? 'Reprovado'
            : 'Em Análise';
    }   

    carregarLista() {
        if (_.isEmpty(this.acoesPlanejamentoOficina)) {
            this.mostrarTabela = false;
            this.msg = 'Nenhuma ação cadastrada.';
        } else {
            this.dataSource.data = this.acoesPlanejamentoOficina;
            this.mostrarTabela = true;
        }

        this.filteredRequests = this.dataSource;
    }

    deletar(acaoPlanejamentoOficina: any): void {
        const index = this.acoesPlanejamentoOficina.indexOf(this.acoesPlanejamentoOficina.find(item => item === acaoPlanejamentoOficina));
        if (index >= 0) {
            this.acoesPlanejamentoOficina.splice(index, 1);
            this.carregarLista();
        }
    }

    atualizar(acaoPlanejamentoOficina: AcoesPlanejamentoOficina) {
        this.onAtualizarAcaoPlanejamentoOficina.emit(acaoPlanejamentoOficina);
    }

    novo() {
        this.onAdicionar.emit(true);
    }

    onMascaraDataInput(event) {
        return this.dataUtilService.onMascaraDataInput(event);
    }

    get descricaoFilter(): string {
        return this.descricaoFiltered;
    }

    set descricaoFilter(value: string) {
        this.descricaoFiltered = value;
        this.filteredRequests = this.performFilter();
    }

    get dataFilter(): string {
        return this.dataFiltered;
    }

    set dataFilter(value: string) {
        this.dataFiltered = value;
        this.filteredRequests = this.performFilter();
    }

    performFilter(): MatTableDataSource<AcoesPlanejamentoOficina> {
        let filteredRequestsX = this.dataSource.data.filter(
            (request: AcoesPlanejamentoOficina) => (!this.descricaoFiltered || request.descricao.includes(this.descricaoFiltered)) &&
                (!this.dataFiltered || this.dataUtilService.getDataTruncata(request.dataInicio).toString().includes(this.dataFiltered))
        );
        return !!this.descricaoFiltered || !!this.dataFiltered
            ? new MatTableDataSource(filteredRequestsX)
            : this.dataSource;
    }

}
